<template>
    <div v-if="showModal" id="order_modal_edit" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">발주 주문 정보</h3>
            </div>
            <div id="body" class="ui segment">
                <div class="ui form">
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">주문 날짜</label>
                        <input type="text" v-model="item.orderedAt" autocomplete=off disabled>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">타입</label>
                            <select class="ui simple dropdown" v-model="item.type" @change="checkChanged">
                                <option :value="constant.TYPE_DELIVERY">배송</option>
                                <option :value="constant.TYPE_INSTALL">설치</option>
                                <option :value="constant.TYPE_EXCHANGE">교환</option>
                                <option :value="constant.TYPE_RECALL">회수</option>
                                <option :value="constant.TYPE_AS">A/S</option>
                            </select>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">상품</label>
                            <input type="text" v-model="item.product" autocomplete=off disabled>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">수량</label>
                            <input type="number" v-model="item.count" autocomplete=off @change="checkChanged">
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">주문자</label>
                            <input type="text" v-model="item.orderer" autocomplete=off disabled>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">주문자 전화번호</label>
                            <input type="text" v-model="item.ordererTel" autocomplete=off disabled>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">수취인</label>
                            <input type="text" v-model="item.receiver" autocomplete=off @change="checkChanged">
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">수취인 전화번호</label>
                            <input type="text" v-model="item.receiverTel" autocomplete=off @change="checkChanged">
                        </div>
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">수취인 주소</label>
                        <input type="text" v-model="item.address" autocomplete=off @change="checkChanged">
                        <div class="ui fluid teal basic button" @click="searchAddress">주소 검색</div>
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">고객요청사항</label>
                        <input type="text" v-model="item.clientMemo" autocomplete=off @change="checkChanged">
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">메모(설치유형)</label>
                        <input type="text" v-model="item.partnerMemo" autocomplete=off @change="checkChanged">
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div v-if="isChanged" class="ui orange left labeled icon button" @click="save">
                    <i class="checkmark icon"></i>변경
                </div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>

const openSearchAddressPopup = (onComplete) => {
    new daum.Postcode({
        oncomplete: function(data) {
            onComplete(data);
        }
    }).open();
};

export default {
    data: function() {
        return { showModal: 0, isChanged: 0, item: 0, oldItem: 0, onChange: 0 }
    },
    created: function() {
        this.showModal = false;
        this.isChanged = this.item = this.oldItem = this.onChange = 0;
    },
    mounted: function() {
        this.$event.set("open_edit_order", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("open_edit_order");
    },
    methods: {
        open(item, onChange) {
            this.showModal = true;
            this.isChanged = false;
            this.oldItem = item;
            this.item = JSON.parse(JSON.stringify(item));
            this.onChange = onChange;
        },
        close() {
            this.showModal = false;
        },
        save() {
            if (this.checkChanged()) {
                this.$event.call("openLoading");
                this.$address.search(this.item.address, (err, region1, region2, addressX, addressY) => {
                    this.$event.call("closeLoading");
                    if (err) {
                        alert(err);
                    } else {
                        this.item.region1 = region1;
                        this.item.region2 = region2;
                        this.item.addressX = addressX;
                        this.item.addressY = addressY;
                        this.onChange(this.item);
                        this.close();
                    }
                });
                // this.$api.searchAddress(this.item.address, (resData) => {
                //     if (resData.documents && resData.documents.length > 0) {
                //         const address = resData.documents[0].address;
                //         const region1 = address.region_1depth_name;
                //         const region2 = address.region_2depth_name;
                //         const region3 = address.region_3depth_name;
                //         if (address && Boolean(region1)) {
                //             if (Boolean(region2) || Boolean(region3)) {
                //                 this.item.addressX = address.x;
                //                 this.item.addressY = address.y;
                //                 this.close();
                //                 this.onChange(this.item, region1, region2, region3);
                //                 return;
                //             }
                //         }
                //     }
                //     alert("주소를 찾을 수 없습니다! 정확한 주소를 입력하세요!");
                // });
            }
        },
        checkChanged() {
            this.isChanged = false;
            if (this.oldItem.type != this.item.type) this.isChanged = true;
            if (this.oldItem.count != this.item.count) this.isChanged = true;
            if (this.oldItem.receiver != this.item.receiver) this.isChanged = true;
            if (this.oldItem.receiverTel != this.item.receiverTel) this.isChanged = true;
            if (this.oldItem.address != this.item.address) this.isChanged = true;
            if (this.oldItem.clientMemo != this.item.clientMemo) this.isChanged = true;
            if (this.oldItem.partnerMemo != this.item.partnerMemo) this.isChanged = true;
            return this.isChanged;
        },
        searchAddress() {
            openSearchAddressPopup((data) => {
                this.item.address = data.address;
                this.checkChanged();
                this.$forceUpdate();
            });
        },
    },
    computed: {
        isHeader: function() { return this.$store.getters.isHeader; },
        centers: function() { return this.$store.getters.centers; },
        partners: function() { return this.$store.getters.partners; },
        constant: function() { return this.$store.getters.constant; },
    },
}
</script>

<style>
#order_modal_edit {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#order_modal_edit .column {
    max-width: 700px;
}

#order_modal_edit #header {
    padding: 20px 30px;
}

#order_modal_edit #body {
    padding: 50px;
}

#order_modal_edit #body .ui.form {
    padding: 10px;
}

#order_modal_edit #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#order_modal_edit .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/OrderModal_Edit.vue